import cx from 'classnames';
import { type FC, type PropsWithChildren, memo } from 'react';

import BackButton from 'components/BackButton';
import useLayout from 'utils/layout';

import styles from './SubHeader.module.scss';

const SubHeader: FC<PropsWithChildren> = memo(({ children }) => {
  const layout = useLayout();

  return (
    <div className={cx(styles.wrapper, styles[layout])}>
      <BackButton />
      <div className={styles.line} />
      <div className={styles.right}>{children}</div>
    </div>
  );
});

export default SubHeader;
